module.exports = __webpack_public_path__ + "static/media/emoji-disagree.76c03c2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/emoji-disagree.svg
// module id = 454
// module chunks = 0